module.exports = __webpack_public_path__ + "static/img/promote.a49eec8d.png";